import BadgerAccordion from 'badger-accordion';
import { detectMobile, debounceEvent } from '../../../js/utils';

export default class FooterNavigation {
  initializedAccordion() {
    const accordions = document.querySelectorAll('.js-swa-footer-nav');

    if (!accordions ) {
      return;
    }

    if (detectMobile()) {
      const headerClass = '.js-swa-footer-nav__header__button';
      const panelClass = '.js-swa-footer-nav__panel';
      const panelInnerClass = ".js-swa-footer-nav__panel-inner";
      const activeClass = 'swa-footer-nav--active'; // The activeClass should not contain the "."

      Array.from(accordions).forEach((accordion) => {
        const navigationAccordion = new BadgerAccordion(accordion, {
          headerClass: headerClass,
          panelClass: panelClass,
          panelInnerClass: panelInnerClass,
          activeClass: activeClass,
        });
      });

    } else {
      Array.from(accordions).forEach((accordion) => {
        const navigationAccordion = new BadgerAccordion(accordion);
        navigationAccordion.openAll();
      });
    }
  }

  init() {
    if (detectMobile()) {
      this.initializedAccordion();
      return;
    }; 

    // SWANSL-24206 - it appears that because of this resize listener, this bug happens
    // The fix above should result in the desired behaviour, without side effects (do not quote me on that though)
  
    window.addEventListener(
      'resize',
      debounceEvent(() => this.initializedAccordion(), 50)
    );

  }
}